import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import { compose } from "redux";
import DeliveryChargesList from "./DeliveryChargesList";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import siteSettingReducer from "store/SiteSetting/reducer";
import siteSettingSaga from "store/SiteSetting/saga";

const siteSettingKey = "SiteSetting";

const withSiteSettingReducer = injectReducer({
  key: siteSettingKey,
  reducer: siteSettingReducer,
});
const withSiteSettingSaga = injectSaga({
  key: siteSettingKey,
  saga: siteSettingSaga,
});

class Index extends Component {
  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <h4 className="mt-0 page-title">Delivery Charges</h4>
                  </div>

                  <DeliveryChargesList />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default compose(
  withSiteSettingReducer,
  withSiteSettingSaga,
  withRouter
)(Index);
//export default withRouter(withConnect)(Index);
